import { useForm } from 'react-hook-form'
import {
  AppNames,
  ChatCenteredDotsIcon,
  ModalDialog,
  Mtds,
  PaperPlaneTiltIcon,
  useCreateUserFeedback,
  useErrorToast,
  XIcon
} from 'prove-common'
import { AnimatedCheckMark } from '../animated-check-mark/AnimatedCheckMark'

type EnterFeedbackProps = {
  isOpen: boolean
  setOpen: (isOpen: boolean) => void
  appName: AppNames
}

export const EnterFeedback = ({
  isOpen,
  setOpen,
  appName
}: EnterFeedbackProps) => {
  const { handleSubmit, register } = useForm<{ feedback: string }>()
  const createFeedback = useCreateUserFeedback()
  const showError = useErrorToast('sende tilbakemeldingen')

  const handleFeedbackSubmit = async (data: { feedback: string }) => {
    try {
      await createFeedback.mutateAsync({
        feedback: data.feedback,
        application: appName,
        context: globalThis.location.toString()
      })
    } catch (error) {
      showError(error)
    }
  }

  return (
    <ModalDialog
      id='enter-feedback-modal'
      closedby='any'
      open={isOpen}
      onClose={() => setOpen(false)}
    >
      {!createFeedback.isSuccess && (
        <>
          <Mtds.Button
            command='close'
            commandfor='enter-feedback-modal'
            aria-label={'Lukk'}
          />
          <Mtds.Prose
            as='form'
            noValidate
            onSubmit={handleSubmit(handleFeedbackSubmit)}
          >
            <ChatCenteredDotsIcon />
            <Mtds.Heading>Gi oss din tilbakemelding</Mtds.Heading>
            <p>
              Vi vil gjerne høre hva du synes om produktet. Husk å ikke oppgi
              sensitiv informasjon som personopplysninger eller konfidensielle
              data.
            </p>
            <Mtds.Field>
              <Mtds.Textarea
                {...register('feedback')}
                placeholder='Skriv her...'
                maxLength={500}
                rows={4}
              />
              <Mtds.Validation data-field={'counter'} data-limit={500} />
            </Mtds.Field>
            <Mtds.Button
              data-variant='primary'
              aria-busy={createFeedback.isPending}
              disabled={createFeedback.isPending}
              type='submit'
            >
              Send
              <PaperPlaneTiltIcon />
            </Mtds.Button>
          </Mtds.Prose>
        </>
      )}
      {createFeedback.isSuccess && (
        <Mtds.Grid
          data-justify='center'
          data-align={'center'}
          data-gap={8}
          data-color={'success'}
          className={'py-4'}
        >
          <AnimatedCheckMark />
          <Mtds.Prose data-justify='center'>
            <Mtds.Heading data-justify={'center'}>
              Takk for tilbakemeldingen
            </Mtds.Heading>
            <p>
              Vi setter stor pris på at du delte dine tanker. Det hjelper oss
              med å forbedre løsningen.
            </p>
          </Mtds.Prose>
          <Mtds.Button data-variant='secondary' onClick={() => setOpen(false)}>
            Lukk
            <XIcon />
          </Mtds.Button>
        </Mtds.Grid>
      )}
    </ModalDialog>
  )
}
